import { useCallback } from 'react';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import {
  type ChangeProjectTypeMutationVariables,
  ChangeProjectTypeDocument,
  ProjectTypesDocument,
} from 'graphql/generated/graphql';

const useChangeProjectType = () => {
  const [changeProjectTypeMutation] = useMutation(ChangeProjectTypeDocument);

  const mutate = useCallback(
    async ({ projectId, type }: ChangeProjectTypeMutationVariables) => {
      try {
        await changeProjectTypeMutation({
          variables: { projectId, type },
          refetchQueries: [{ query: ProjectTypesDocument, variables: { projectId } }],
        });
      } catch (error) {
        const e = formatGraphqlErrors(error);
        throw e;
      }
    },
    [changeProjectTypeMutation],
  );

  return mutate;
};

export default useChangeProjectType;
